<div class="recipes-wrapper">
    <app-site-nav></app-site-nav>

    <!-- Hero -->
    <section class="rx-hero">
        <span class="rx-kicker">Recipes</span>
        <h1>Your procedures, <span>on autopilot</span></h1>
        <p>A recipe is a set of steps you save once — then LIAM runs it on a schedule or a trigger, across every app
            you've connected. No dashboards, no code. Just tell LIAM what to do.</p>
        <div class="rx-hero-cta">
            <a class="rx-btn rx-btn-fill" href="#gallery">Browse recipes</a>
            <a class="rx-btn rx-btn-ghost" href="#byo">Create your own</a>
        </div>
    </section>

    <!-- How it works -->
    <section class="rx-how">
        <div class="rx-how-card">
            <div class="rx-how-num">1</div>
            <h3>Describe the steps</h3>
            <p>In plain English — “read my email, check my notes, email me a summary.” LIAM saves it as a reusable
                recipe.</p>
        </div>
        <div class="rx-how-card">
            <div class="rx-how-num">2</div>
            <h3>Pick when it runs</h3>
            <p>Daily, weekly, monthly, or on a trigger (a new email, a finished meeting). Powered by Claude routines.</p>
        </div>
        <div class="rx-how-card">
            <div class="rx-how-num">3</div>
            <h3>LIAM runs it</h3>
            <p>It executes across your connectors — Gmail, Calendar, Drive, Slack, Stripe, your memory — and reports
                back the way you asked.</p>
        </div>
    </section>

    <!-- Gallery -->
    <section class="rx-gallery" id="gallery">
        <div class="rx-sec-head">
            <h2>Recipe gallery</h2>
            <p>Real procedures you can save today. Tap a card for the steps, then copy the prompt into Claude.</p>
        </div>

        <div class="rx-tabs">
            <button *ngFor="let c of categories" class="rx-tab" [class.active]="activeCategory === c.key"
                [class.rx-tab-live]="c.key === 'live'" (click)="setCategory(c.key)">
                <span class="rx-tab-dot" *ngIf="c.key === 'live'"></span>{{ c.label }}</button>
        </div>

        <p class="rx-live-note" *ngIf="activeCategory === 'live'">
            These {{ liveCount }} run in production at NetXD every working day — same steps, same connectors you see
            here. Ask for a live walkthrough on any of them.
        </p>

        <div class="rx-grid">
            <div class="rx-card" *ngFor="let r of filteredRecipes" [class.expanded]="expandedId === r.id"
                [class.featured]="r.featured" (click)="toggle(r.id)">
                <div class="rx-card-top">
                    <span class="rx-cadence" [ngClass]="'cad-' + r.cadence">{{ cadLabel(r.cadence) }}</span>
                    <span class="rx-featured-tag" *ngIf="r.featured">Flagship</span>
                    <span class="rx-live-tag" *ngIf="r.live">Live at NetXD</span>
                </div>
                <h3>{{ r.title }}</h3>
                <p class="rx-desc">{{ r.desc }}</p>

                <ol class="rx-steps" *ngIf="expandedId === r.id">
                    <li *ngFor="let s of r.steps">{{ s }}</li>
                </ol>

                <div class="rx-conns">
                    <span class="rx-conn" *ngFor="let c of r.connectors">{{ c }}</span>
                </div>

                <div class="rx-actions">
                    <button class="rx-copy" (click)="copyPrompt(r.id, r.prompt, $event)">
                        <svg *ngIf="copiedId !== r.id" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" width="15" height="15">
                            <rect x="9" y="9" width="13" height="13" rx="2" />
                            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
                        </svg>
                        <svg *ngIf="copiedId === r.id" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" width="15" height="15">
                            <polyline points="20 6 9 17 4 12" />
                        </svg>
                        {{ copiedId === r.id ? 'Copied!' : 'Copy prompt' }}
                    </button>
                    <a class="rx-try" [href]="claudeUrl" target="_blank" rel="noopener" (click)="$event.stopPropagation()">
                        Try in Claude
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14"
                            height="14">
                            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                            <polyline points="15 3 21 3 21 9" />
                            <line x1="10" y1="14" x2="21" y2="3" />
                        </svg>
                    </a>
                    <a class="rx-demo" *ngIf="r.live" [href]="demoLink(r.title)"
                        (click)="$event.stopPropagation()">Request a demo</a>
                    <span class="rx-expand-hint">{{ expandedId === r.id ? 'Hide steps' : 'Show steps' }}</span>
                </div>
            </div>
        </div>
    </section>

    <!-- Build your own -->
    <section class="rx-byo" id="byo">
        <h2>Build your <span>own recipe</span></h2>
        <p>You don't fill out a form. You tell LIAM in a sentence and it saves the procedure — then you say “run my
            morning brief” any time, or let it run on schedule.</p>
        <div class="rx-byo-quote">
            <span class="q">You:</span> “Save a recipe called Morning Brief: read my overnight email, flag anything
            critical, check my memory for related notes, then email me a one-page summary and post it to Slack — every
            weekday at 7am.”
        </div>
        <a class="rx-btn rx-btn-fill" routerLink="/login">Get started free</a>
    </section>

    <!-- Footer -->
    <footer class="rx-footer">
        <span>© 2025 LIAM. All rights reserved.</span>
        <div class="rx-footer-links">
            <a routerLink="/story">Our Story</a>
            <a routerLink="/login">Sign In</a>
            <a routerLink="/developers">Developers</a>
        </div>
    </footer>
</div>
